/**
 * Replace composition `(+)/(-)` with `◖+◗/◖-◗`
 * @param {String} input
 * @returns {String}
 */
const replaceComposition = (input) => {
  let result = input;

  const hasAdd = input.includes("(+)");
  const hasReduce = input.includes("(-)");

  if (hasAdd || hasReduce) {
    if (hasAdd) {
      result = result.replace(/\(\+\)/g, "◖+◗");
    }
    if (hasReduce) {
      result = result.replace(/\(\-\)/g, "◖-◗");
    }
  } else {
    return input;
  }

  return result;
};

export default replaceComposition;
